import type { SelectedChannel } from '~publish/pages/Channel/ChannelContext'

import { isOfType } from '../../helpers/typeGuards'

type SelectedChannelMetadata = SelectedChannel['metadata']

type PinterestBoard = NonNullable<
  Extract<
    SelectedChannelMetadata,
    { __typename: 'PinterestMetadata' }
  >['boards']
>[number]

export const usePinterestBoards = (
  metadata: SelectedChannelMetadata | undefined,
): Array<PinterestBoard> | undefined => {
  if (isOfType(metadata, 'PinterestMetadata') && metadata.boards) {
    return metadata.boards
  }
}

export const useIsTwitterPremium = (
  metadata: SelectedChannelMetadata | undefined,
): boolean => {
  if (isOfType(metadata, 'TwitterMetadata')) {
    return (
      metadata.subscriptionType === 'Basic' ||
      metadata.subscriptionType === 'Premium' ||
      metadata.subscriptionType === 'PremiumPlus'
    )
  }
  return false
}

export const useMastodonMaxCharacters = (
  metadata: SelectedChannelMetadata | undefined,
): number | undefined => {
  if (isOfType(metadata, 'MastodonMetadata')) {
    return metadata.maxCharacters
  }
  return undefined
}
